import moment from 'moment'

/**
 * Collection of useful functions, mostly date stuff
 */
export default {

    /**
     * Determine whether a date in the YYYY-MM-DD format
     * refers to a day before today.
     */
    isOverdue(date: Date | string) {
        let yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        return (new Date(date) <= yesterday)
    },

    /**
     * Return the difference in days between two YYYY-MM-DD dates.
     *
     * The difference is computed as date2-date1 using moment.js,
     * and can be a negative number.
     */
    daysBetween(date1: Date | string, date2: Date | string): number {
        let start = moment(date1, 'YYYY-MM-DD')
        let end = moment(date2, 'YYYY-MM-DD')
        return Math.floor(moment.duration(end.diff(start)).asDays())
    },

    /**
     * Return the number of days between the given date (given in YYYY-MM-DD
     * format and today; it will be a negative number if the given date is in
     * the past.
     */
    daysFromToday(date: Date | string): number {
        return this.daysBetween(moment().format('YYYY-MM-DD'), date)
    },

    /**
     * Given two dates, return the one in the future
     */
    max(date1: Date | string, date2: Date | string): Date {
        let d1 = new Date(date1)
        let d2 = new Date(date2)
        return (d1 > d2) ? d1 : d2
    },

    /**
     * Given two dates, return the one in the past
     */
    min(date1: Date | string, date2: Date | string): Date {
        let d1 = new Date(date1)
        let d2 = new Date(date2)
        return (d1 < d2) ? d1 : d2
    },

    printHistogram(histogramData: Object) {
        // $('#output').append('<div id="container" style="width: 75%;">')
        // $('#output').append('<canvas id="canvas"></canvas>')
        // $('#output').append('</div>')
    },
}
